import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";

const CorporateCart = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  
    const [cartData, setCartData] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
        const fetchCarts = async () => {
          try {
            setLoading(true);
            const res = await fetch(`${baseurl}/admin/customer/corporates/carts`);
            const data = await res.json();
    
            if (data.success) {
              setCartData(data.data);
              setPagination(data.pagination);
            } else {
              setCartData([]);
            }
          } catch (err) {
            console.error("Fetch carts error:", err);
          } finally {
            setLoading(false);
          }
        };
    
  fetchCarts();
      }, [baseurl]);
  const columns = useMemo(
    () => [
      {
        Header: "Cart ID",
        accessor: "id",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "	Cart No",
        accessor: "cart_no",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Customer Name",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Created Date",
        accessor: "created_at",
        filterable: true,
      },

      {
        Header: "Updated Date",
        accessor: "updated_at",
        filterable: true,
      },
      {
        Header: "Order Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => (
          <Badge color={value === "Converted" ? "success" : "danger"}>
                      {value.charAt(0).toUpperCase() + value.slice(1)}
                    </Badge>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          const status = row.original.status;
          const isExpired = status === "expired";
          return (
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={`/manage-request/cart/corporate-customers/cart-list/${row.original.cart_no}`}
                className={`text-success ${isExpired ? "disabled-link" : ""}`}
                aria-disabled={isExpired}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit Cart
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  document.title = "Corporate Customer Cart | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Cart"
            breadcrumbItem="Corporate Customer Cart List"
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={cartData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CorporateCart;
